























































import Vue from "vue";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import * as AmplifyUI from "@aws-amplify/ui";

export default Vue.extend({

  name: 'AuthRequirePassword',
  props: ['requireNewPasswordConfig'],
  data() {
    return {
      error: '',
      user: '',
      requiredAttributes: {},
      password: '',
      rePassword: '',
      showPassword: false,
      showRePassword: false,
      emailRules: [
        (v: any) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: {
        required: (value: any) => !!value || 'Required.',
        min: (v: string | any[]) => v.length >= 6 || 'Min 6 characters'
      },
      busy: false,
    }
  },
  computed: {
    options(): any {
      const defaults = {
        user: {
          challengeParam: {
            requiredAttributes: []
          }
        }
      };
      return Object.assign(defaults, this.requireNewPasswordConfig || {})
    }
  },
  mounted() {
  },
  methods: {
    setError: function (e: any) {
      this.error = e.message || e;
    },
    checkContact(user: any) {
      Auth.verifiedContact(user)
        .then(data => {
          AmplifyEventBus.$emit('localUser', this.user);
          AmplifyEventBus.$emit('authState', 'signedIn')
        })
        .catch((e) => this.setError(e))
    },
    change() {
      if (!this.validate()) {
        return null;
      }
      this.busy = true;
      Auth.completeNewPassword(this.options.user, this.password, this.requiredAttributes)
        .then(user => {
          if (this.options.user.challengeName === 'SMS_MFA') {
            //Not supported right now
            AmplifyEventBus.$emit('localUser', this.options.user)
            AmplifyEventBus.$emit('authState', 'confirmSignIn')
          } else if (this.options.user.challengeName === 'MFA_SETUP') {
            //Not supported right now
            AmplifyEventBus.$emit('localUser', this.options.user)
            AmplifyEventBus.$emit('authState', 'setMfa')
          } else {
            this.checkContact(this.options.user);
          }
          this.busy = false;
        })
        .catch(err => {
          this.busy = false;
          this.setError(err)
        });
    },
    signIn: function () {
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    validate() {
      return (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },
  }
});
